// extracted by mini-css-extract-plugin
export default {"wrapper":"Text-module__wrapper___Fw21u","textContent":"Text-module__textContent___EtKAg"};